import { Button, ButtonGroup, Col, Row, Modal, ModalHeader, ModalFooter, ModalBody, Input } from 'reactstrap';

export default function AddCommentModal({ isCompanyUser, comment, setComment, autofocus, privateToName,
		commentPrivate, setCommentPrivate, commentUrgent, setCommentUrgent, onClose, onSubmit }) {
	return (<Modal autoFocus={false} fullscreen="sm" toggle={onClose} isOpen>
    <ModalHeader>
      Add Comment
    </ModalHeader>
    <ModalBody>
      <Input type='textarea' autoFocus={autofocus} className="comment-textarea" maxLength="800" value={comment} onChange={(e) => setComment(e.target.value)} />
      {isCompanyUser ? (
				<Row>
					<Col sm="7">
						<div className='mb-1' style={{cursor: "pointer"}} onClick={(e) => {
								e.stopPropagation();
								setCommentPrivate(!commentPrivate);
							}}>
							<Input type="checkbox" checked={commentPrivate} onChange={(e) => {
								e.stopPropagation();
								setCommentPrivate(!commentPrivate);
							}} /> Private to {privateToName}
						</div>
					</Col>
					{setCommentUrgent
						? (<Col>
								<div className='mb-1' style={{cursor: "pointer"}} onClick={(e) => {
										e.stopPropagation();
										setCommentUrgent(!commentUrgent);
									}}>
									<Input type="checkbox" checked={commentUrgent} onChange={(e) => {
										e.stopPropagation();
										setCommentUrgent(!commentUrgent);
									}} /> Private &amp; Urgent
								</div>
							</Col>)
						: null
					}
				</Row>
			) : null}
    </ModalBody>
    <ModalFooter>
      <Row className='d-flex justify-content-end'>
        <Col>
          <ButtonGroup className="float-end">
            <Button color='primary' onClick={onSubmit}>Save</Button>
            <Button onClick={onClose}>Close</Button>
          </ButtonGroup>
        </Col>
      </Row>
    </ModalFooter>
  </Modal>);
}